<div class="lesson-desc_row1--stat-lesson-desc" *ngIf="lesson">
  <div class="test-col">
    <span class="bold_span--stat-lesson-desc">{{ lesson.title }}</span>
    &nbsp;
    <span *ngIf="lesson.remarks">({{ lesson.remarks }})</span>
  </div>
  <div class="blank--stat-lesson-desc">

  </div>
</div>
<div class="lesson-desc_row2--stat-lesson-desc" *ngIf='show_second_row'>
  <div class="lesson-desc_column1--stat-lesson-desc">
    Длительность:&nbsp;<span class="bold_span--stat-lesson-desc number-span--stat-lesson-desc" *ngIf="lesson">{{ lesson.duration }}</span>&nbsp;мин.
  </div>
  <div class="lesson-desc_column2--stat-lesson-desc">
    <span>Ср. скорость:&nbsp;<span class="bold_span--stat-lesson-desc number-span--stat-lesson-desc" *ngIf="avg_resolve_speed">{{ avg_resolve_speed }}</span>&nbsp;вар./мин.</span>&nbsp;|&nbsp;
    <span class="currency_span--stat-lesson-desc" *ngIf="avg_amount_speed !== null">
      <span class="bold_span--stat-lesson-desc number-span--stat-lesson-desc" >{{ avg_amount_speed }}</span>&nbsp;
      <span *ngIf="currency">{{ declensionOfNumerals(avg_amount_speed) }}/мин.</span>
    </span>
  </div>
  <div class="lesson-desc_column1--stat-lesson-desc extra-exercise" *ngIf="extra_exercise">
    <span class="extra-exercise__main-title"><p>Доп. задание</p>:</span>
    <span>{{ extra_exercise?.title }}</span>
    <span class="extra-exercise__count">{{ getFormData(extra_exercise?.count_correct, extra_exercise?.count_incorrect) }}</span>
  </div>
</div>
